import { Divider } from "--floponents-web/atoms/Divider";
import { ListEntrySurfaceHighlight } from "--floponents-web/atoms/ListEntry";
import { ListSelectionContextProvider } from "--floponents-web/molecules/ListEntries/ListSurface/ListSelectionContext";
import * as React from "react"
import styled from "styled-components";

export interface ListSurfaceProps {
    children: JSX.Element[],
    onSelectedItem(idx: number): void,
    tabSelects?: boolean,
    keyboardDisabled?: boolean,
    allowClickThrough?: boolean
    EntryWrapper?: React.FC<{ onClick?: () => void, index: number, allowClickThrough?: boolean }>,
    dividerPosition?: number
}

const ListDivider = styled(Divider)`
    padding:${props => props.theme.spacing(1)} ${props => props.theme.spacing(2)};
    margin-right:${props => props.theme.spacing(2)};
    color: ${props => props.theme.palette.ui.divider};
`


export const ListSurface: React.FC<ListSurfaceProps> = props => {
    const children = React.Children.toArray(props.children);
    const { EntryWrapper = ListEntrySurfaceHighlight } = props;
    const indexToRefMap = React.useRef(new Map<HTMLElement, number>()).current
    indexToRefMap.clear()


    const bounds = React.useMemo(() => {
        return {
            maximumIndex: children.length - 1
        }
    }, [children.length])
    return <ListSelectionContextProvider bounds={bounds} keyboardDisabled={props.keyboardDisabled} tabSelects={props.tabSelects} onSelectedItem={props.onSelectedItem} >
        {children.map((child, idx) => {
            return <EntryWrapper
                index={idx}
                allowClickThrough={props.allowClickThrough}
                key={(child as any)?.key || idx}
                onClick={!!props.onSelectedItem ? () => props.onSelectedItem && props.onSelectedItem(idx) : undefined}>
                {child}
                {props.dividerPosition !== undefined && (props.dividerPosition - 1) === idx && <ListDivider />}
            </EntryWrapper>
        })}
    </ListSelectionContextProvider>
}